import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { getMasterReviewer } from '../../../redux/actions/masterReviewer'
import ExpertAccountSearchAndTableWidget from '../../../widgets/admin/manage/ExpertAccountSearchAndTableWidget'

export default function ManageExpertAccounts() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [projectVersionId, setProjectVerprojectVersionId] = useState()
  const [schemaForEdit, setSchemaForEdit] = useState()

  useEffect(() => {
    handleGetSchema()
    //setSchema(mockSchemas.model)
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getMasterReviewer(5, 1, '', '', '')
      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isManagement>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema) {
    return (
      <SidebarProposal isManagement>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isManagement>
      <ContentHeader header={schema?.title} isNotCallApi />

      <ExpertAccountSearchAndTableWidget haveAccountColumn={true} schema={schema} />
    </SidebarProposal>
  )
}
